const dataRoadMap = [
  {
    id: 1,
    time: 'January 2023',
    title: 'Idea Validation',
    desc: 'Conceptualized a platform to automate forex trading using AI-powered algorithms with minimal manual intervention.',
  },
  {
    id: 2,
    time: 'March 2023',
    title: 'Architecture Design',
    desc: 'Finalized system architecture including client dashboard, master panel, and secure trading integration modules.',
  },
  {
    id: 3,
    time: 'June 2023',
    title: 'Core Development',
    desc: 'Developed the trading engine, integrated MT4/MT5 connectivity, and implemented backend automation logic.',
  },
  {
    id: 4,
    time: 'September 2023',
    title: 'Beta Testing',
    desc: 'Rolled out beta access to selected users, collected feedback, and optimized trading logic and UI.',
  },
  {
    id: 5,
    time: 'November 2023',
    title: 'Live Launch',
    desc: 'Official launch of PipPlus Tech platform with live trading bots and client onboarding.',
  },
  {
    id: 6,
    time: 'January 2024',
    title: 'Analytics & Reports',
    desc: 'Introduced real-time performance reports, client dashboards, and automated P&L tracking.',
  },
  {
    id: 7,
    time: 'May 2024',
    title: 'Franchise Expansion',
    desc: 'Launched affiliate and franchise program with revenue sharing, onboarding support, and training.',
  },
  {
    id: 8,
    time: 'Upcoming',
    title: 'Mobile App Release',
    desc: 'Released Android/iOS apps to monitor trades, receive insights, and manage client activity on the go.',
  },
];

export default dataRoadMap;
